import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "home",
    component: () => import("../components/home.vue")
  },
  {
    path: "/reservation",
    name: "reservation",
    component: () => import("../components/reservation.vue"),
    props(route) {
      return route.query || {};
    }
  }
];

const router = new VueRouter({
  mode: "history",
  routes
});

export default router;
